module.exports = __webpack_public_path__ + "static/media/understand.6bf8b4ae.jpg";